'use client'

import clsx from 'clsx'
import { useTranslations } from 'next-intl'

import { useNewsTags } from '@/features/news/hooks'

import type { NewsTagFilter } from '../../utils/newsTags'
import S from './NewsCategoryNav.module.scss'

type NewsCategoryNavProps = {
  selectedTag: NewsTagFilter
  onTagChange: (tag: NewsTagFilter) => void
}

const NewsCategoryNav = ({
  selectedTag,
  onTagChange
}: NewsCategoryNavProps) => {
  const t = useTranslations('news')
  const { data: tags = [] } = useNewsTags()

  const filters: { id: NewsTagFilter; label: string }[] = [
    { id: 'all', label: t('browse.all') },
    ...tags.map(({ tag, label }) => ({ id: tag, label }))
  ]

  return (
    <nav className={S.root} aria-label={t('browse.filtersAriaLabel')}>
      <h2 className={S.title}>{t('browse.title')}</h2>
      <div
        className={S.filters}
        role="group"
        aria-label={t('browse.filtersAriaLabel')}
      >
        {filters.map(filter => {
          const isActive = selectedTag === filter.id

          return (
            <button
              key={filter.id}
              type="button"
              className={clsx(S.filterButton, {
                [S.filterButtonActive]: isActive
              })}
              aria-pressed={isActive}
              onClick={() => onTagChange(filter.id)}
            >
              {filter.label}
            </button>
          )
        })}
      </div>
    </nav>
  )
}

export default NewsCategoryNav
